import { render, staticRenderFns } from "./PartnerList.vue?vue&type=template&id=34f53c4e&scoped=true&"
import script from "./PartnerList.vue?vue&type=script&lang=ts&"
export * from "./PartnerList.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerList.vue?vue&type=style&index=0&id=34f53c4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f53c4e",
  null
  
)

export default component.exports